"use client";

import { useState } from "react";
import Image from "next/image";
import TrainingLibraryModal from "app/resources/src/TrainingLibraryModal/training-library-modal";
import { ResourceCategory } from "app/resources/src/TrainingLibraryModal/trainingFiles";
const resourceLinks: {
  href: string;
  icon: string;
  label: string;
  category: ResourceCategory;
}[] = [{
  href: "#platform-guide",
  icon: "/assets/images/resource/wyl-video.svg",
  label: "Platform Training\nGuides",
  category: "platform-guide"
}, {
  href: "#client-marketing",
  icon: "/assets/images/resource/wyl-marking.svg",
  label: "Client Marketing\nMaterials",
  category: "client-marketing"
}, {
  href: "#webinars",
  icon: "/assets/images/resource/wyl-recording.svg",
  label: "Webinars Assets\n& Recordings",
  category: "webinars"
}];
const ResourceTabItem = () => {
  const [selectedCategory, setSelectedCategory] = useState<ResourceCategory | null>(null);
  const selectedResource = resourceLinks.find(resource => resource.category === selectedCategory);
  return <>
      <section className='text-center'>
        <nav aria-label='Resource categories' className='bg-white'>
          <div className='mx-auto block max-w-[1440px] grid-cols-2 md:grid md:grid-cols-3 md:px-4 md:py-[25px] lg:px-[80px]'>
            {resourceLinks.map((resource, index) => <a key={resource.href} href={resource.href} onClick={event => {
            event.preventDefault();
            setSelectedCategory(resource.category);
          }} className={`md:justify-left flex min-h-[72px] items-center justify-center gap-3 px-4 py-4 text-center text-base font-bold leading-[22px] text-[#26262B] transition-colors hover:bg-[rgba(3,50,67,0.10)] xsm:text-lg md:min-h-[58px] md:gap-6 md:px-2 md:text-base lg4:px-3 lg4:text-[22px] xl:px-5 xll2:px-10 ${index === 0 ? "!gap-5 border-b border-[#866E3F] md:border-b-0 md:!pl-0" : ""} ${index > 0 ? "border-[#866E3F] md:border-l" : ""} ${index > 1 ? "border-t border-[#866E3F] md:border-t-0" : ""}`}>
                <Image src={resource.icon} alt='' width={51} height={50} className='h-[34px] w-[30px] object-contain sm:h-[38px] sm:w-[38px] lg2:h-[50px] lg2:w-[51px]' />

                <span className='text-start md:whitespace-pre-line'>
                  {resource.label}
                </span>
              </a>)}
          </div>
        </nav>
      </section>

      {selectedResource && <TrainingLibraryModal isOpen={!!selectedCategory} onClose={() => setSelectedCategory(null)} title={selectedResource.label.replace("\n", " ")} category={selectedResource.category} />}
    </>;
};
export default ResourceTabItem;